import React from "react"

export const DrawerContext = React.createContext()

export const useDrawerContext = () => React.useContext(DrawerContext)

export default DrawerContext
